import "./style.less";
// eslint-disable-next-line no-unused-vars
import iconRepeat from "./assets/icon-repeat.svg";

export default function basketBooking(moment) {
    return {
        restrict: "E",
        scope: {
            booking: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, $rootScope, $timeout, Basket) {
            $scope.showRepeaetableTooltip = false;

            // $scope.currentBookings = Basket.currentBookings;

            $scope.activity = Basket.getBookingActivity();

            var tooltipListener = $rootScope.$on(
                "show-tooltip-repeatable",
                function ($event, args) {
                    if (args.repeatedBooking) {
                        if (
                            $scope.booking.Periods[0].UniqueKey ==
                            args.repeatedBooking.Periods[0].UniqueKey
                        ) {
                            $scope.showRepeaetableTooltip = true;

                            $timeout(function () {
                                //$scope.showRepeaetableTooltip = false;
                            }, 5000);
                        }
                    }

                    tooltipListener(); // calling the named event kills it
                }
            );
            $scope.$on("$destroy", tooltipListener);

            $scope.closeTooltip = function ($event) {
                $event.preventDefault();

                $scope.showRepeaetableTooltip = false;
            };

            $scope.removeBooking = function (booking) {
                booking.Periods[0].selected = false;

                // INTERNAL USE
                // var index = $scope.currentBookings.indexOf(booking);
                // $scope.currentBookings.splice(index, 1);

                // EXTERNAL
                Basket.removePeriod(booking.Periods[0]);
            };

            /**
             * Loop through all bookings in basket
             * then make sure only one collapsible is open
             * @param  {obj} booking - Has the collapsed property
             * $scope.currentBookings - used to loop bookings in basket
             * Broadcast to show/hide buttons depending on state
             */
            $scope.toogleCollapsed = function (booking) {
                $scope.showRepeaetableTooltip = false;

                Basket.currentBookings.forEach((currentBooking) => {
                    if (currentBooking == booking) {
                        booking.isCollapsed = booking.isCollapsed
                            ? false
                            : true;
                    } else {
                        currentBooking.isCollapsed = true;
                    }
                });

                $rootScope.$broadcast("any-repeabable-collapsed", {
                    collapsed: booking.isCollapsed,
                });
            };

            // Create label for WCAG compliance
            $scope.getSRFriendlyAriaLabel_for_PeriodTime = function (
                start,
                end
            ) {
                return `klokken ${moment(start).hours()} ${
                    moment(start).minutes() > 0 ? moment(start).minutes() : ""
                } til ${moment(end).hours()} ${
                    moment(end).minutes() > 0 ? moment(end).minutes() : ""
                }`;
            };
        },
    };
}
